import { render } from "./template.vue?vue&type=template&id=bba15380&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=bba15380&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba15380"]])

export default __exports__